// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 종목 관리 화면 - 공통 스타일은 PageLayout.css 참조 */

/* 조회 조건 툴바 */
.stock-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.stock-toolbar select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

/* 관리자 사용자 선택 콤보 - 강조 표시 */
.stock-user-select {
  border-color: #4a90e2 !important;
  color: #1a5ca8;
  font-weight: 600;
  min-width: 160px;
}

/* 폼 제목 옆 선택된 사용자 표시 */
.stock-form-user-badge {
  font-size: 12px;
  font-weight: 400;
  color: #4a90e2;
  margin-left: 4px;
}

/* 좌우 분할 레이아웃 */
.stock-body {
  display: flex;
  gap: 16px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* 좌측 그리드 패널 */
.stock-list-panel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 텍스트 말줄임 컬럼 */
.col-ellipsis {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #555;
}

/* 사용/미사용 뱃지 */
.badge-active {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.badge-inactive {
  background: #fce4ec;
  color: #c62828;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

/* 지표종목 뱃지 */
.badge-benchmark {
  background: #e3f2fd;
  color: #1565c0;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

/* 폼 라벨 옆 도움말 아이콘 */
.sf-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  margin-left: 4px;
  border-radius: 50%;
  background: #aaa;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
  vertical-align: middle;
}

.sf-help:hover { background: #777; }

/* ── 우측 폼 패널 ── */
.stock-form-panel {
  width: 310px;
  flex-shrink: 0;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  padding: 14px 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* 폼 타이틀 */
.stock-form-title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

/* 가로 레이아웃 행 (라벨 + 입력) */
.sf-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}

/* 라벨 고정 너비 */
.sf-row > label {
  width: 80px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  text-align: right;
}

/* 입력요소 공통 - 남은 공간 채우기 */
.sf-row input[type="text"],
.sf-row input[type="number"],
.sf-row select {
  flex: 1 1;
  min-width: 0;
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  transition: border-color 0.2s;
}

.sf-row input:focus,
.sf-row select:focus {
  outline: none;
  border-color: #4a90e2;
}

.sf-row select:disabled {
  background: #f5f5f5;
  color: #aaa;
  cursor: not-allowed;
}

/* 숫자 입력 + 단위(%) */
.sf-input-suffix {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.sf-input-suffix input {
  flex: 1 1;
  min-width: 0;
}

.sf-suffix {
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
}

/* 체크박스 행 */
.sf-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sf-checkbox input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
}

.sf-checkbox-label {
  font-size: 12px;
  color: #333;
  cursor: pointer;
  font-weight: normal !important;
  text-align: left !important;
  width: auto !important;
}

/* 신규/저장 버튼 영역 */
.sf-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: flex-end;
}

.required { color: #e74c3c; }
`, "",{"version":3,"sources":["webpack://./src/pages/reference/StockMasterPage.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,iBAAiB,gBAAgB,EAAE;;AAEnC,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;;;EAGE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,YAAY,cAAc,EAAE","sourcesContent":["/* 종목 관리 화면 - 공통 스타일은 PageLayout.css 참조 */\n\n/* 조회 조건 툴바 */\n.stock-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.stock-toolbar select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n/* 관리자 사용자 선택 콤보 - 강조 표시 */\n.stock-user-select {\n  border-color: #4a90e2 !important;\n  color: #1a5ca8;\n  font-weight: 600;\n  min-width: 160px;\n}\n\n/* 폼 제목 옆 선택된 사용자 표시 */\n.stock-form-user-badge {\n  font-size: 12px;\n  font-weight: 400;\n  color: #4a90e2;\n  margin-left: 4px;\n}\n\n/* 좌우 분할 레이아웃 */\n.stock-body {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* 좌측 그리드 패널 */\n.stock-list-panel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* 텍스트 말줄임 컬럼 */\n.col-ellipsis {\n  max-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #555;\n}\n\n/* 사용/미사용 뱃지 */\n.badge-active {\n  background: #e8f5e9;\n  color: #2e7d32;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.badge-inactive {\n  background: #fce4ec;\n  color: #c62828;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* 지표종목 뱃지 */\n.badge-benchmark {\n  background: #e3f2fd;\n  color: #1565c0;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* 폼 라벨 옆 도움말 아이콘 */\n.sf-help {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 13px;\n  height: 13px;\n  margin-left: 4px;\n  border-radius: 50%;\n  background: #aaa;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  cursor: help;\n  vertical-align: middle;\n}\n\n.sf-help:hover { background: #777; }\n\n/* ── 우측 폼 패널 ── */\n.stock-form-panel {\n  width: 310px;\n  flex-shrink: 0;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 폼 타이틀 */\n.stock-form-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n/* 가로 레이아웃 행 (라벨 + 입력) */\n.sf-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 7px;\n}\n\n/* 라벨 고정 너비 */\n.sf-row > label {\n  width: 80px;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  text-align: right;\n}\n\n/* 입력요소 공통 - 남은 공간 채우기 */\n.sf-row input[type=\"text\"],\n.sf-row input[type=\"number\"],\n.sf-row select {\n  flex: 1;\n  min-width: 0;\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  transition: border-color 0.2s;\n}\n\n.sf-row input:focus,\n.sf-row select:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.sf-row select:disabled {\n  background: #f5f5f5;\n  color: #aaa;\n  cursor: not-allowed;\n}\n\n/* 숫자 입력 + 단위(%) */\n.sf-input-suffix {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.sf-input-suffix input {\n  flex: 1;\n  min-width: 0;\n}\n\n.sf-suffix {\n  font-size: 12px;\n  color: #666;\n  flex-shrink: 0;\n}\n\n/* 체크박스 행 */\n.sf-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.sf-checkbox input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.sf-checkbox-label {\n  font-size: 12px;\n  color: #333;\n  cursor: pointer;\n  font-weight: normal !important;\n  text-align: left !important;\n  width: auto !important;\n}\n\n/* 신규/저장 버튼 영역 */\n.sf-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  justify-content: flex-end;\n}\n\n.required { color: #e74c3c; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
